module.exports = __webpack_public_path__ + "img/wide.6d073e36.jpg";